import { all } from 'redux-saga/effects';

import fetchElevatorStates from './fetchElevatorStates';

export default function* () {
    yield all([fetchElevatorStates()]);
}
